import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig} from 'primeng/api';

@Component({
  selector: 'app-imgpopup',
  templateUrl: './imgpopup.component.html',
  styleUrls: ['./imgpopup.component.css']
})
export class ImgpopupComponent implements OnInit {
  uploadedFiles:any = [];
  img:any = {};
  constructor(public config: DynamicDialogConfig) { }

  ngOnInit() {
    this.uploadedFiles = this.config.data;
    this.img = this.uploadedFiles.files[0];
  }

  onRightClick(event) {
    if(event.keyCode == 123) {
      return false;
    }
    return false;
  }
  
  public showImg(u) {
    this.img = u;
  }
}
